import { useSite } from '../hooks';
import { Seo } from '../Seo';
import { Hero } from '../sections/Hero';
import { Intro } from '../sections/Intro';
import { Clients } from '../sections/Clients';
import { Stats } from '../sections/Stats';
import { Work } from '../sections/Work';
import { Services } from '../sections/Services';
import { Process } from '../sections/Process';
import { Faq } from '../sections/Faq';
import { Finale } from '../sections/Finale';
import { PageLoader, PageError } from './states';
import { useLocale } from '../i18n';

export function HomePage() {
  const { data, isLoading, error, refetch } = useSite();
  const { to } = useLocale();
  if (isLoading) return <PageLoader />;
  if (error || !data) return <PageError error={error} onRetry={() => refetch()} />;
  const s = data.settings;
  return (
    <>
      <Seo
        title={s.siteTitle}
        description={s.metaDescription}
        image={s.ogImage?.url}
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: s.ownerName,
          jobTitle: s.roles.split('\n')[0],
          description: s.metaDescription,
          image: s.heroPortrait?.url,
          url: `${window.location.origin}${to('/')}`,
          sameAs: data.socials.filter((l) => l.url.startsWith('http')).map((l) => l.url),
        }}
      />
      <Hero s={s} />
      <Intro data={data} />
      <Clients heading={s.clientsHeading} clients={data.clients} showStories={s.bannerEnabled} />
      <Stats stats={data.statistics} />
      <Work s={s} />
      <Services s={s} services={data.services} />
      <Process s={s} steps={data.process} />
      <div id="insights">
        <Faq heading={s.faqHeading} items={data.faq} />
      </div>
      <Finale data={data} />
    </>
  );
}
